import { render, staticRenderFns } from "./SimpleButton.vue?vue&type=template&id=2dcf8ee2&"
import script from "./SimpleButton.vue?vue&type=script&lang=ts&"
export * from "./SimpleButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports